import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useDisconnectCognism(tenant: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axios.delete(`${getBongoUrl()}/v1/org/${tenant}/integrations/cognism`);
    },
    onSuccess: () => {
      queryClient.setQueryData(['cognism', tenant], false);
    },
  });
}
